export default "__VITE_ASSET__00031c7e__"